import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import MaskColumns from './mask-columns'

export type MaskTransitionHandler = {
  enterTimeline: () => gsap.core.Timeline
  leaveTimeline: () => gsap.core.Timeline
  resetTimeline: () => void
}

/* .to('[data-mask-transparent]', { yPercent: -100, duration: 1, ease: 'power3.out' }, 0)
.to('[data-mask-loader]', { yPercent: 100, duration: 1, ease: 'power3.out' }, 0) */

const MaskTransition = forwardRef<MaskTransitionHandler>((_, ref) => {
  const root = useRef<HTMLDivElement>(null)

  const { contextSafe } = useGSAP({ scope: root })

  const enterTimeline = contextSafe(() => {
    return gsap
      .timeline({})
      .fromTo(
        '[data-mask-accent]',
        { yPercent: 100, opacity: 0 },
        {
          yPercent: 100,
          opacity: 0.6,
          duration: 1,
          ease: 'power2.in'
        }
      )
      .fromTo(
        ['[data-mask-l-white]', '[data-mask-r-white]'],
        { yPercent: 100, scaleY: 0 },
        {
          yPercent: 100,
          scaleY: 1,
          transformOrigin: 'bottom',
          duration: 1,
          ease: 'power3.in',
          stagger: 0.12
        },
        0
      )
      .fromTo(
        '[data-mask-transparent]',
        { yPercent: 200 },
        { yPercent: 100, duration: 1, ease: 'power3.in' },
        0
      )
      .fromTo(
        '[data-mask-loader]',
        { yPercent: -100 },
        { yPercent: 0, duration: 1, ease: 'power3.in' },
        0
      )
  })

  const leaveTimeline = contextSafe(() => {
    return gsap
      .timeline()
      .fromTo(
        '[data-mask-accent]',
        { yPercent: 100, opacity: 1 },
        {
          yPercent: 100,
          opacity: 0,
          duration: 1,
          ease: 'power2.out',
          clearProps: true
        }
      )
      .fromTo(
        ['[data-mask-l-white]', '[data-mask-r-white]'],
        { yPercent: 100, scaleY: 1 },
        {
          yPercent: 100,
          scaleY: 0,
          transformOrigin: 'top',
          duration: 1,
          ease: 'power3.out',
          stagger: 0.12,
          clearProps: true
        },
        0
      )
      .fromTo(
        '[data-mask-transparent]',
        { yPercent: 100 },
        { yPercent: 0, duration: 1, ease: 'power3.out' },
        0
      )
      .fromTo(
        '[data-mask-loader]',
        { yPercent: 0 },
        { yPercent: 100, duration: 1, ease: 'power3.out' },
        0
      )
  })

  const resetTimeline = contextSafe(() => {
    gsap.set(
      [
        '[data-mask-accent]',
        '[data-mask-l-white]',
        '[data-mask-r-white]',
        '[data-mask-transparent]'
      ],
      {
        yPercent: 100
      }
    )
  })

  useImperativeHandle(
    ref,
    () => ({
      leaveTimeline,
      enterTimeline,
      resetTimeline
    }),
    [enterTimeline, leaveTimeline, resetTimeline]
  )

  return (
    <MaskColumns
      ref={root}
      className="pointer-events-none fixed -top-full left-0 z-transition h-full w-full"
    />
  )
})

export default MaskTransition
